import qs from 'query-string';
import strings from 'strings';
import { SEARCH_PROJECT_SOURCES, SelectionType } from 'UI/constants/defaults';
import { EntityType } from 'UI/constants/entityTypes';

const { alerts: alertsCopies } = strings.searchProjects;

const PARAMS_KEY_NAMES = {
  exclude: 'search_params',
  include: 'search_project_selected_items'
};

const SPACED_ENTITIES_KEYS = {
  HiringAuthority: 'Hiring Authority',
  JobOrder: 'Job Order'
};

// TODO: ADD UNIT TEST AFTER REFACTOR SPS
const fillItems = (items, key) =>
  items.map(({ id, type_id }) => ({ id, [key]: parseInt(type_id, 10) }));

export const fillSearchProjectSelectionParams = (selectedItems, queryParams) => {
  const { data, type } = selectedItems;
  const dataHasItems = data.length > 0;
  const filledData = dataHasItems ? fillItems(data, 'item_search_project_type') : [];
  if (type === SelectionType.Include && dataHasItems)
    return { key: PARAMS_KEY_NAMES.include, data: filledData };
  if (type === SelectionType.Exclude || queryParams)
    return {
      key: PARAMS_KEY_NAMES.exclude,
      data: {
        query: qs.parse(queryParams.params),
        exclude: filledData
      }
    };
  return {};
};

/**
 * @typedef FilteredItemsData
 * @property {Number} id
 * @property {String} type
 * @property {Number} type_id
 */

/**
 * @param {FilteredItemsData[]} filteredItems - Object containing items to add, type and count
 * that will be transformed to an object containing items ordered by their type
 *
 * @returns {{
 *  candidates: number[],
 *  hiring_authorities: number[],
 *  names: number[],
 *  job_orders: number[],
 *  companies: number[]
 *  applicants: number[]
 * }} Object containig multiple entities arrays, data inside filteredItems
 * is ordered by item's type
 */
// TODO: ADD UNIT TEST AFTER REFACTOR SPS
export const fillIncludedItems = filteredItems => {
  const searchProjectEntitiesList = {
    [SPACED_ENTITIES_KEYS.HiringAuthority]: [],
    [SPACED_ENTITIES_KEYS.JobOrder]: [],
    Applicant: [],
    Candidate: [],
    Company: [],
    Item: [],
    Name: []
  };
  filteredItems.forEach(item => {
    searchProjectEntitiesList[item.type] = [...searchProjectEntitiesList[item.type], item.id];
  });
  return {
    applicants: [...searchProjectEntitiesList.Applicant],
    candidates: [...searchProjectEntitiesList.Candidate],
    companies: [...searchProjectEntitiesList.Company],
    hiring_authorities: [...searchProjectEntitiesList[SPACED_ENTITIES_KEYS.HiringAuthority]],
    items: [...searchProjectEntitiesList.Item],
    job_orders: [...searchProjectEntitiesList[SPACED_ENTITIES_KEYS.JobOrder]],
    names: [...searchProjectEntitiesList.Name]
  };
};

export const buildMasterListPayloadProperties = ({
  canMarkAsMasterList,
  geoPolygon,
  isMasterList,
  seatCount
}) => {
  if (canMarkAsMasterList) {
    const basePayload = { is_master_list: isMasterList, seat_count: seatCount };

    if (typeof geoPolygon === 'object' && geoPolygon.id) {
      const isPolygonEmpty = !geoPolygon.polygon;
      return {
        ...basePayload,
        geoPolygons: isPolygonEmpty ? [{ id: geoPolygon.id, mustBeDeleted: true }] : [geoPolygon]
      };
    }
    return { ...basePayload, geoPolygons: geoPolygon ? [{ polygon: geoPolygon }] : [] };
  }

  return null;
};

/**
 * @typedef {Object} FormatValues
 * @property {string} action
 * @property {string} entity
 */

/**
 *
 * @param {FormatValues} formatValues
 * @returns {Object}
 */
export const getGeneralErrorAlert = ({ action, entity }) => ({
  title: strings.formatString(alertsCopies.error.general.title, {
    action,
    entity
  })
});

/**
 * @param {string} action
 * @returns {Object}
 */
export const getFoldersGeneralErrorAlert = action => ({
  title: strings.formatString(alertsCopies.error.general.title, {
    action
  })
});

/**
 * @param {string} action
 * @returns {string}
 */
export const getFoldersGeneralSuccessTitle = action =>
  strings.formatString(alertsCopies.success.generalTitle, {
    action,
    entity: alertsCopies.entities.folder
  });

/**
 * @typedef {Object} ArchiveAlertConfig
 * @property {string} entity
 * @property {boolean} inArchiveFeatureActive
 */

/**
 *
 * @param {ArchiveAlertConfig}
 * @returns {Object}
 */
export const getArchiveAlerts = entity => ({
  success: {
    title: strings.formatString(alertsCopies.success.generalTitle, {
      action: alertsCopies.success.actions.archive,
      entity
    }),
    body: alertsCopies.success.archiveGeneralBody
  },
  error: getGeneralErrorAlert({
    action: alertsCopies.error.actions.archive,
    entity
  })
});

export const buildIndustryDetailsParams = ({ extraPayloadData, formData }) => {
  const isFromProspectingAssistant =
    extraPayloadData?.sourceId === SEARCH_PROJECT_SOURCES.coresignal.id;
  const isProspectingCompany = extraPayloadData?.entityType === EntityType.Company;
  if (!isFromProspectingAssistant) return null;

  const { positionId, specialtyId, subSpecialtyId } = formData;

  return isProspectingCompany
    ? { specialtyId, subSpecialtyId }
    : { positionId, specialtyId, subSpecialtyId };
};

export const buildImportOptionsParams = ({ extraPayloadData, formData }) => {
  const isFromProspectingAssistant =
    extraPayloadData?.sourceId === SEARCH_PROJECT_SOURCES.coresignal.id;
  if (!isFromProspectingAssistant) return null;

  const { importTarget = {}, prospectType = {}, skipDuplicates = {} } = formData;

  return {
    importOptions: {
      ...importTarget,
      ...prospectType,
      ...skipDuplicates
    }
  };
};
